export class EmailAttachment {
    public id: string;
    public fileName: string;

    public static from(other: any) {
        if (!!other) {
            const instance = new EmailAttachment();

            instance.id = other.Id;
            instance.fileName = other.FileName;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne un tableau d'instances de EmailAttachment à partir d'un tableau d'instances de Any.
     * @param other : Tableau d'instances de Any.
     * @returns : Tableau d'instances de EmailAttachment.
     */
    public static fromArray(others: any[]) {
        if (!!others) {
            let attachments: EmailAttachment[] = [];

            others.forEach((x) => {
                const attachment = EmailAttachment.from(x);
                attachments.push(attachment);
            });

            return attachments;
        } else {
            return null;
        }
    }
}
